import React from "react";
import "./index.css";

const AnticipatedDate = ({
  input,
  meta,
  schemaProps: { label, machine_name, choice, value },
  ...rest
}) => {
  let showError = meta.error && meta.touched;

  // 9142B datahub name case
  if (machine_name === "jobHoursTotal") {
    machine_name = machine_name.toLowerCase();
  }

  return (
    <div
      className={
        machine_name.indexOf("total") < 0
          ? "anticipated_date_day"
          : "anticipated_date_total"
      }
    >
      {machine_name.includes("total") ? (
        <div>
          <div className={"anticipated_date_total_group"}>
            <label
              value={choice}
              className="usa-label anticipated_date_total_label"
              htmlFor={machine_name}
            >
              {choice}
            </label>
            <input
              id={machine_name}
              title={label}
              value={value}
              className="usa-input anticipated_date_total_input"
              {...input}
              readOnly
              type="number"
            />
            <span className={"anticipated_date_label"}>hours</span>
          </div>
          <p>
            <em>Total must be at least 35 hours per week.</em>
          </p>
          {meta.error && (
            <div className="usa-error-message" role="alert">
              {meta.error}
            </div>
          )}
        </div>
      ) : (
        <div>
          <label value={choice} className="usa-label" htmlFor={machine_name}>
            {choice}
          </label>
          <input
            id={machine_name}
            value={value}
            className="usa-input"
            {...input}
            type="number"
          />
          {showError && (
            <div className="usa-error-message" role="alert">
              {meta.error}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AnticipatedDate;
